import React from 'react';

export const IconSearch = () => {
	return (
		<svg
			width="16px"
			height="16px"
			viewBox="0 0 16 16"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="search" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path
					d="M7,0 C10.8659932,0 14,3.13400675 14,7 C14,8.57637665 13.478928,10.0310504 12.5996286,11.2011767 C12.6038133,11.2027022 12.608368,11.2061812 12.6128994,11.2097046 L12.7071068,11.2928932 L15.7071068,14.2928932 C16.0976311,14.6834175 16.0976311,15.3165825 15.7071068,15.7071068 C15.3466228,16.0675907 14.7793918,16.0953203 14.3871006,15.7902954 L14.2928932,15.7071068 L11.2928932,12.7071068 C11.2586889,12.6729024 11.2274804,12.6368368 11.1992676,12.5992358 C10.0310504,13.478928 8.57637665,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M7,2 C4.23857625,2 2,4.23857625 2,7 C2,9.76142375 4.23857625,12 7,12 C9.76142375,12 12,9.76142375 12,7 C12,4.23857625 9.76142375,2 7,2 Z"
					id="Combined-Shape"
					fill="currentColor"
					fillRule="nonzero"
				></path>
			</g>
		</svg>
	);
};
